// extracted by mini-css-extract-plugin
export default {"positionContainer":"_Position_positionContainer__mPk08","companyImg":"_Position_companyImg__nD0HJ","descriptionList":"_Position_descriptionList__TMGNX"};